import {
  Text,
  Heading,
  Stack,
  Container,
  Row,
  Col,
  Button,
  Visible,
  Hidden,
  Inline,
  useBreakpoint,
  Icon
} from '@leroy-merlin-br/backyard-react'
import { LeroyLogo } from '@backyard-ui/icons'

import * as dataLayer from 'scripts/utils/data-layer'

import * as S from './styled'

const HeroBanner = () => {
  const { breakpoint } = useBreakpoint()
  const isMobile = ['untilKilo', 'kilo'].includes(breakpoint)

  const queryParams = new URLSearchParams(location.search)
  const storeParam = queryParams.get('store')
  const associatePath = storeParam
    ? `https://leroymerlin.rmaffiliate.com/register?store=${storeParam}`
    : 'https://leroymerlin.rmaffiliate.com/register'

  const assetsPath = window && window.env.assetHost

  return (
    <S.Section>
      <Container>
        <Row reverse="mega">
          <Col size={{ giga: 6 }} offset={{ giga: 1 }}>
            <Visible when={['untilKilo', 'kilo', 'mega']}>
              <Inline alignX="flex-end">
                <S.IconWrapper>
                  <Icon as={LeroyLogo} />
                </S.IconWrapper>
              </Inline>
            </Visible>
            <S.WrapperImage>
              <S.Image
                src={`${assetsPath}assets/images/affiliates/hero-banner.png`}
              />
            </S.WrapperImage>
          </Col>
          <Col size={{ giga: 5 }}>
            <Stack space="giga">
              <Hidden when={['untilKilo', 'kilo', 'mega']}>
                <S.IconWrapper>
                  <Icon as={LeroyLogo} />
                </S.IconWrapper>
              </Hidden>
              <S.TitleWrapper>
                <Heading size="zetta" noMargin>
                  Indique Produtos da Leroy Merlin e{' '}
                  <span>comece a lucrar</span>!
                </Heading>
              </S.TitleWrapper>

              <S.SubtitleWrapper>
                <Text size="mega" color="n500" noMargin>
                  Nosso Programa de Afiliados é um benefício para parceiros!
                  Agora você recebe uma recompensa em dinheiro pelas vendas
                  realizadas através do seu link exclusivo!
                </Text>
              </S.SubtitleWrapper>
            </Stack>
            <S.ButtonWrapper>
              <Button
                as="a"
                href={associatePath}
                isStretch={isMobile}
                onClick={dataLayer.loyaltyLandingPageHeroBannerButton}>
                Cadastre-se
              </Button>
            </S.ButtonWrapper>
          </Col>
        </Row>
      </Container>
    </S.Section>
  )
}

export default HeroBanner
